import { useState } from 'react';

const Feedback = () => {
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    
    // Récupération des données du formulaire
    const formData = new FormData(e.currentTarget);
    
    // Log de toutes les données du formulaire
    // console.log('Données du formulaire :');
    for (const [key, value] of formData.entries()) {
      console.log(`${key}: ${value}`);
    }

    // Log spécifique pour les features (car c'est un champ multiple)
    const features = formData.getAll('features');
    // console.log('Features sélectionnées:', features);

    // Création d'un objet avec toutes les données
    const formDataObject = {
      usage: formData.get('usage'),
      satisfaction: formData.get('satisfaction'),
      features: features,
      willing_to_pay: formData.get('willing_to_pay'),
      price_range: formData.get('price_range'),
      improvement: formData.get('improvement'),
      email: formData.get('email')
    };
    
    // console.log('Objet de données complet:', formDataObject);

    // Soumission du formulaire
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        "form-name": "feedback",
        ...Object.fromEntries(formData)
      }).toString()
    })
    .then(() => {
      // console.log('Formulaire soumis avec succès');
      setSubmitted(true);
    })
    .catch((error) => {
      console.error('Erreur lors de la soumission du formulaire:', error);
    });
  };

  if (submitted) {
    return (
      <div className="flex flex-col items-center justify-center min-h-[60vh] p-4">
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Merci pour votre retour !</h2>
        <p className="text-gray-600">Votre avis est précieux pour améliorer l'application.</p>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto p-4">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Votre avis compte</h1>
      <p className="text-gray-600 mb-8">
        Merci pour vos retours précieux ! Votre avis nous aide à améliorer VCard Pro et vous pourriez être parmi les premiers à tester nos nouvelles fonctionnalités premium.
      </p>

      <form
        name="feedback"
        method="POST"
        data-netlify="true"
        onSubmit={handleSubmit}
        className="space-y-6"
      >
        <input type="hidden" name="form-name" value="feedback" />

        <div>
          <label htmlFor="usage" className="block text-sm font-medium text-gray-700 mb-2">
            Comment utilisez-vous principalement VCard Pro ?
          </label>
          <select
            name="usage"
            id="usage"
            required
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Sélectionnez une option</option>
            <option value="personal">Usage personnel</option>
            <option value="professional">Usage professionnel</option>
            <option value="both">Les deux</option>
          </select>
        </div>

        <div>
          <label htmlFor="satisfaction" className="block text-sm font-medium text-gray-700 mb-2">
            Quel est votre niveau de satisfaction global ?
          </label>
          <div className="flex gap-4">
            {[1, 2, 3, 4, 5].map((value) => (
              <label key={value} className="flex items-center">
                <input
                  type="radio"
                  name="satisfaction"
                  value={value}
                  required
                  className="mr-2"
                />
                {value}
              </label>
            ))}
          </div>
        </div>

        <div>
          <label htmlFor="features" className="block text-sm font-medium text-gray-700 mb-2">
            Quelles fonctionnalités utilisez-vous le plus ? (plusieurs choix possibles)
          </label>
          <div className="space-y-2">
            <label className="flex items-center">
              <input type="checkbox" name="features" value="qr" className="mr-2" />
              Génération de QR code
            </label>
            <label className="flex items-center">
              <input type="checkbox" name="features" value="sharing" className="mr-2" />
              Partage de profil
            </label>
            <label className="flex items-center">
              <input type="checkbox" name="features" value="customization" className="mr-2" />
              Personnalisation du profil
            </label>
          </div>
        </div>

        <div>
          <label htmlFor="willing_to_pay" className="block text-sm font-medium text-gray-700 mb-2">
            Seriez-vous prêt(e) à payer pour accéder à des fonctionnalités avancées ?
          </label>
          <div className="space-y-2">
            <label className="flex items-center">
              <input 
                type="radio" 
                name="willing_to_pay" 
                value="yes" 
                className="mr-2"
                required 
              />
              Oui
            </label>
            <label className="flex items-center">
              <input 
                type="radio" 
                name="willing_to_pay" 
                value="no" 
                className="mr-2" 
              />
              Non
            </label>
            <label className="flex items-center">
              <input 
                type="radio" 
                name="willing_to_pay" 
                value="maybe" 
                className="mr-2" 
              />
              Peut-être
            </label>
            <label className="flex items-center">
              <input 
                type="radio" 
                name="willing_to_pay" 
                value="depends" 
                className="mr-2" 
              />
              Cela dépend des fonctionnalités proposées
            </label>
          </div>
        </div>

        <div>
          <label htmlFor="price_range" className="block text-sm font-medium text-gray-700 mb-2">
            Quel tarif mensuel trouveriez-vous raisonnable pour une version premium ?
          </label>
          <div className="space-y-2">
            <label className="flex items-center">
              <input 
                type="radio" 
                name="price_range" 
                value="1.99" 
                className="mr-2"
                required 
              />
              1,99 €/mois
            </label>
            <label className="flex items-center">
              <input 
                type="radio" 
                name="price_range" 
                value="3.99" 
                className="mr-2" 
              />
              3,99 €/mois
            </label>
            <label className="flex items-center">
              <input 
                type="radio" 
                name="price_range" 
                value="5.99" 
                className="mr-2" 
              />
              5,99 €/mois
            </label>
            <label className="flex items-center">
              <input 
                type="radio" 
                name="price_range" 
                value="9.99" 
                className="mr-2" 
              />
              9,99 €/mois
            </label>
          </div>
        </div>

        <div>
          <label htmlFor="improvement" className="block text-sm font-medium text-gray-700 mb-2">
            Que pourrions-nous améliorer ?
          </label>
          <textarea
            name="improvement"
            id="improvement"
            rows={4}
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Vos suggestions..."
          ></textarea>
        </div>

        <div>
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
            Votre email (optionnel)
          </label>
          <input
            type="email"
            name="email"
            id="email"
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="email@exemple.com"
          />
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors"
        >
          Envoyer mon retour
        </button>
      </form>
    </div>
  );
};

export default Feedback;
